<script lang="typescript">
  import Panel from '../common/Panel.svelte';
  import { useMachine } from '@xstate/svelte';
  import { createJoinMachine } from './joinMachine';
  import type { JoinEvent } from './joinMachine';
  import type { JoinOptions } from './types';
  export let options:JoinOptions = {};
  let key:string = "";
  const machine  = createJoinMachine();
  const { state, send } = useMachine(machine);
  const join = () => {
    if (key) {
      send({ type: 'JOIN', key: key } as JoinEvent);
    }
  };
  $: keyNotFound = $state.matches('no_key_found');
  $: isError = $state.matches('error');
  $: disabled = $state.matches('fetching');
  $: fetching = $state.matches('fetching');
  $: redirecting = $state.matches('key_found');
  $: placeholder = "Anna ajanvarauksen avain";
  $: joinClass = options.join_class || "no-join-class";
</script>

<div class="{joinClass}">
  {#if isError}
    <Panel reverse={true} type="error">
      <h3>Järjestelmävirhe</h3>
      <p>Ajanvarauksen avaimeen liittyvää tapaamista ei pystytty noutamaan palvelimelta. Yritä hetken kuluttua uudelleen.</p>
    </Panel>
  {/if}
  
  {#if keyNotFound}
    <Panel type="error">
      <p>
      Ajanvarauksen avaimella ei löytynyt tapaamista. Tarkistathan että avain on oikein kirjoitettu.
      </p>
      <p>
      Jos avain on sama kuin saamassasi sähköpostissa otathan yhteyttä asiakaspalveluun.
      </p>
    </Panel>
  {/if}
    {#if fetching}
      <p>
      <i class="fas fa-spinner fa-spin fa-lg"></i>
      Haetaan tapaamisen tietoja...
      </p>
    {:else if redirecting}
      <p>
      <i class="fas fa-spinner fa-spin fa-lg"></i>
      Siirrytään tapaamiseen...
      </p>
    {:else}
    <div>
      <form on:submit|preventDefault={join}>
        <input id="ticket-key-input" bind:value={key} {disabled} required type="text" placeholder={placeholder}/>
        <button>
          Osallistu
          <span class="ikoni">
            <i class="fas fa-chalkboard-teacher"></i>
          </span>
        </button>
      </form>
    </div>
    {/if}
</div>

<style>
</style>
